import { ExecutionRequestStatus } from "@/lib/interfaces and Enums/ENUMExecutionRequestStatus";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { ColId } from "../ENUMActionSummaryColIds";
import { StructureTypeCode } from "@/lib/interfaces and Enums/ENUMStructureTypeCode";
import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";


export const defaultStatusCannotBeEdited = [
  // OP
  ExecutionStrategyStatus.Affirmed,
  ExecutionStrategyStatus.NotDealt,
  ExecutionStrategyStatus.Cancelled,
  // RP
  ExecutionRequestStatus.NotDealt,
  ExecutionRequestStatus.Archived,
  ExecutionRequestStatus.DealtAway,
  ExecutionRequestStatus.Affirmed,
  ExecutionRequestStatus.AffirmedPend,
];

export const statusWhenQuoteCellsCannotBeEdited = [
    // OP
  ExecutionStrategyStatus.Affirmed,
  ExecutionStrategyStatus.NotDealt,
  ExecutionStrategyStatus.Cancelled,
  // RP
  ExecutionRequestStatus.NotDealt,
  ExecutionRequestStatus.Archived,
  ExecutionRequestStatus.DealtAway,
  ExecutionRequestStatus.Executed,
  ExecutionRequestStatus.ExecutedPend,
  ExecutionRequestStatus.ExecutedRPChangeRequested,
  ExecutionRequestStatus.ExecutedPendRPChangeRequested,
  ExecutionRequestStatus.ExecutedRPAgreeChange,
  ExecutionRequestStatus.ExecutedPendRPAgreeChange,
  ExecutionRequestStatus.ExecutedOPChangeRequested,
  ExecutionRequestStatus.ExecutedPendOPChangeRequested,
  ExecutionRequestStatus.Affirmed,
  ExecutionRequestStatus.AffirmedPend,
]

//'statusFromAwarded' is assigned a value but never used. - Commented out until used. 11/04
// const statusFromAwarded = [
//   ExecutionRequestStatus.Awarded,
//   ExecutionRequestStatus.Executed,
//   ExecutionRequestStatus.ExecutedOPChangeRequested,
//   ExecutionRequestStatus.ExecutedPend,
//   ExecutionRequestStatus.ExecutedPendOPChangeRequested,
//   ExecutionRequestStatus.ExecutedPendRPAgreeChange,
//   ExecutionRequestStatus.ExecutedPendRPChangeRequested,
//   ExecutionRequestStatus.ExecutedRPAgreeChange,
//   ExecutionRequestStatus.ExecutedRPChangeRequested,
//   ExecutionRequestStatus.Affirmed,
//   ExecutionRequestStatus.AffirmedPend,
// ];

const statusWhenQuoteSizeCanBeEditedSYNREPO = [
  ExecutionRequestStatus.Awarded,
  // ExecutionRequestStatus.Executed,
  // ExecutionRequestStatus.ExecutedOPChangeRequested,
  // ExecutionRequestStatus.ExecutedPend,
  // ExecutionRequestStatus.ExecutedPendOPChangeRequested,
  // ExecutionRequestStatus.ExecutedPendRPAgreeChange,
  // ExecutionRequestStatus.ExecutedPendRPChangeRequested,
  // ExecutionRequestStatus.ExecutedRPAgreeChange,
  // ExecutionRequestStatus.ExecutedRPChangeRequested,
]

const statusWhenQuotedSizeCanBeEditedRegular = [
  ExecutionRequestStatus.Received,
  ExecutionRequestStatus.Quoted,
  ExecutionRequestStatus.OffQuote,
  ExecutionRequestStatus.ReQuoteRequested,
  ExecutionRequestStatus.QuotedExpired,
  ExecutionRequestStatus.QuoteExpired,
  ExecutionRequestStatus.ReSent,
]

const quotedSizeColId = [
  ColId.quotedSizeOutright,
  ColId.quotedSize,
]

const quoteCellsColId = [
  ColId.bidOutright,
  ColId.bid,
  ColId.bidRepo,
  ColId.askOutright,
  ColId.ask,
  ColId.askRepo,
  "ActionSummaryBid",
  "ActionSummaryAsk"
]


export function returnTrueIfCellCanBeEdited(
  status: any,
  colId?: ColId,
  role?: string,
  structureType?: StructureTypeCode,
  fullTradeData?: any,
  params?: any
) {

//Quote cells cannot be edited at Executed
  if(colId && 
    quoteCellsColId.includes(colId) && 
    statusWhenQuoteCellsCannotBeEdited.includes(status)) {
      return false
  }


  //IF NPV STRUCTURE cannot edit quoted size
  let tradeContainsNPVBlocksAll = false;
  if(params) {
    const { isOutright } =
       returnAllTradeDetailsFromGenericParams(params);

    tradeContainsNPVBlocksAll = fullTradeData?.legs?.length > 0 &&
    fullTradeData.legs.every((leg: any) => leg.unwind == "NPV") &&
    !isOutright
  }
  
  // if(tradeContainsNPVBlocksAll) {
  //   return false
  // }
   if(status && (status == ExecutionRequestStatus.AffirmedPend || status == ExecutionStrategyStatus.Affirmed)){
    return false
  }


  //SYN REPO AND SYN REV REPO cannot edit quoted size until Awarded
  // OTHER trades cannot edit quoted size after Awarded
  if(colId && quotedSizeColId.includes(colId)){
    if(structureType == StructureTypeCode.SYNREPO || structureType == StructureTypeCode.SYNREVREP || tradeContainsNPVBlocksAll){
      if(statusWhenQuoteSizeCanBeEditedSYNREPO.includes(status)){
        return true
      } return false
    } else {
      return statusWhenQuotedSizeCanBeEditedRegular.includes(status);
    }
  }

  




  //OTHER
  let statusCanBeEdited = true;
  if (colId && colId == ColId.book) {
    if (role == "OP") {
      statusCanBeEdited = false;
    } else if (role == "RP" && defaultStatusCannotBeEdited.includes(status)) {
      statusCanBeEdited = false;
    }
    return statusCanBeEdited;
  }

  //default
  if (defaultStatusCannotBeEdited.includes(status)) {
    statusCanBeEdited = false;
  }

  return statusCanBeEdited;
}
